export function employeeRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_EMPLOYEE_START":           
        case "FETCH_EMPLOYEES_START":                                 
        case "UPDATE_EMPLOYEE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_EMPLOYEE_FULFILLED":           
        case "FETCH_EMPLOYEES_FULFILLED":                                 
        case "UPDATE_EMPLOYEE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_EMPLOYEE_ERROR":
        case "FETCH_EMPLOYEES_ERROR":
        case "UPDATE_EMPLOYEE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}